module.exports = __webpack_public_path__ + "static/media/avatar.d099e635.jpg";